<template>
  <div class="favoriteBalloon">
    <template v-if="isRegister">
      <div class="favoriteBalloon_on">
        {{ message }}
      </div>
    </template>
    <template v-else>
      <div class="favoriteBalloon_off">
        {{ message }}
      </div>
    </template>
  </div>
</template>

<script>
export default {
  name: 'TkFavoriteBalloon',
  props: {
    isRegister: {
      type: Boolean,
      default: false,
    },
    registerMessage: {
      type: String,
      default: '登録しました',
    },
    notRegisterMessage: {
      type: String,
      default: '削除しました'
    }
  },
  computed: {
    message() {
      return this.isRegister ? this.registerMessage : this.notRegisterMessage
    }
  }
}
</script>

<style lang="scss">
.favoriteBalloon_on {
  color: white;
  font-size: 12px;
  background: #f9423a;
  text-align: center;
  padding: 10px 20px;
  border-radius: 50px;
  width: 84px;
  box-sizing: content-box;
  position: absolute;
  animation-name: fade;
  animation-duration: 3s;
  animation-fill-mode: forwards;
}
.favoriteBalloon_on:after {
  bottom: 0;
  left: 50%;
  -webkit-transform: translate(-50%, 50%);
  -ms-transform: translate(-50%, 50%);
  transform: translate(-50%, 50%);
  position: absolute;
  content: '';
  display: block;
  width: 0;
  height: 0;
  border-style: solid;
  border-width: 10px 10px 0 10px;
  border-color: #f24b3a transparent transparent transparent;
 }

.favoriteBalloon_off {
  color: white;
  font-size: 12px;
  background: #63666a;
  text-align: center;
  padding: 10px 20px;
  border-radius: 50px;
  width: 84px;
  box-sizing: content-box;
  position: absolute;
  animation-name: fade;
  animation-duration: 3s;
  animation-fill-mode: forwards;
}
.favoriteBalloon_off:after {
  bottom: 0;
  left: 50%;
  -webkit-transform: translate(-50%, 50%);
  -ms-transform: translate(-50%, 50%);
  transform: translate(-50%, 50%);
  position: absolute;
  content: '';
  display: block;
  width: 0;
  height: 0;
  border-style: solid;
  border-width: 10px 10px 0 10px;
  border-color: #63666a transparent transparent transparent;
}

@keyframes fade {
  0% {
    opacity: 0;
  }
  50% {
    opacity: 100;
  }
  100% {
    opacity: 0;
  }
}
</style>
